import AccessibilityIcon from "@mui/icons-material/Accessibility";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HistoryIcon from "@mui/icons-material/History";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { useMemo } from "react";
import { ROUTES, USER_PROFILE } from "../constants.js";

const homePage = ({ locales }) => ({
  home: {
    icon: "/assets/aleph-logo.png",
    isImage: true,
    name: locales["home.title"],
    route: ROUTES.HOME,
  },
});

const hostPages = ({ locales }) => ({
  background: {
    icon: AccountCircleIcon,
    name: locales["background.title"],
    route: ROUTES.HOST_BACKGROUND,
  },
  stats: {
    icon: PsychologyIcon,
    name: locales["stats.title"],
    route: ROUTES.HOST_STATS,
  },
  events: {
    icon: CalendarMonthIcon,
    name: locales["events.title"],
    route: ROUTES.HOST_EVENTS,
  },
  log: {
    icon: HistoryIcon,
    name: locales["log.title"],
    route: ROUTES.HOST_LOG,
  },
});

const employeePages = ({ locales }) => ({
  plots: {
    icon: NoteAltIcon,
    name: locales["plots.title"],
    route: ROUTES.PLOTS.BASE,
  },
  behaviour: {
    icon: PsychologyIcon,
    name: locales["behaviour.title"],
    route: ROUTES.BEHAVIOUR.BASE,
  },
  maintenance: {
    icon: BuildCircleIcon,
    name: locales["maintenance.title"],
    route: ROUTES.MAINTENANCE.BASE,
  },
  security: {
    icon: HistoryIcon,
    name: locales["security.title"],
    route: ROUTES.SECURITY.BASE,
  },
});

const adminPages = ({ locales }) => ({
  runs: {
    icon: LibraryBooksIcon,
    name: locales["runs.title"],
    route: ROUTES.RUNS.BASE,
  },
  hosts: {
    icon: AccessibilityIcon,
    name: locales["hosts.title"],
    route: ROUTES.HOSTS.BASE,
  },
});

export default function useNavbarPages({ locales, profile }) {
  return useMemo(() => {
    const home = homePage({ locales });
    const rolePages = {
      [USER_PROFILE.HOST]: { ...home, ...hostPages({ locales }) },
      [USER_PROFILE.EMPLOYEE]: { ...home, ...employeePages({ locales }) },
      [USER_PROFILE.ADMIN]: { ...home, ...adminPages({ locales }) },
    };

    return rolePages[profile] || home;
  }, [locales, profile]);
}
